/***
 *
 *   CONTACTS PAGE
 *   Phase 7 — reference ContactsListView shell: page header + loading skeleton
 *   + ProjectContacts table (toolbar / filters live in that component).
 *
 **********/

import React from 'react';
import { Animate, Skeleton, useProjectContext } from 'components/lib';
import { useUsers, useProjectUsers } from '../../components/hooks/users';
import ProjectContacts from 'views/settings/projects/contacts';
import { useTranslate } from 'app/translations';
import Style from './contacts.tailwind';

const Contacts = () => {
    const { _t } = useTranslate();
    const { selectedProject } = useProjectContext();

    const projectUsers = useProjectUsers(selectedProject?.id);
    const users = useUsers(selectedProject?.id);

    const loading = projectUsers.isLoading || users.isLoading;

    return (
        <Animate>
            <div className={Style.shell}>
                <div className={Style.header}>
                    <h1 className={Style.title}>{_t('contact.label.multiple')}</h1>
                    <p className={Style.description}>{_t('contact.inviteOrganization')}</p>
                </div>

                {loading ? (
                    <div className={Style.loading}>
                        <Skeleton className="h-10 w-full max-w-sm" />
                        <Skeleton className="h-64 w-full" />
                    </div>
                ) : (
                    <ProjectContacts
                        variant="page"
                        users={users}
                        projectUsers={projectUsers}
                    />
                )}
            </div>
        </Animate>
    );
};

export default Contacts;
